module.exports = __webpack_public_path__ + "static/media/ss-x-rr.c91e5dbc.svg";